export default {
  namespaced: true,
  storage_provider: {
    id: 'Id',
    title: "Provedor de Armazenamento",
    name: "Nome",
    description: "Descrição",
    type: "Tipo",
    config: "Configuração",
    folder: "Pasta",
    bucket_name: "Nome do bucket",
    region: "Região",
    access_key_id: "ID da chave de acesso",
    secret_access_key: "Chave de acesso secreta",
    endpoint: "Ponto de extremidade",
    account_name: "Nome da conta",
    account_key: "Chave da conta",
    container_name: "Nome do contêiner",
    sas_token: "Token SAS",
    message: {
      add: "Provedor de Armazenamento Adicionado com Sucesso",
      edit: "Provedor de Armazenamento Editado com Sucesso",
      delete: "Provedor de Armazenamento Excluído Corretamente",
      error: "Ocorreu um erro",
    }
  }
};